(function () {
  'use strict';

  /* @ngdoc object
   * @name main.llicencies
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llicencies', [
      'ui.router',
      'itecAdministracio.entitats.main.llicencies.formulari'
    ]);
}());
